import React, { memo } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { Paper, Grid, Typography } from '@mui/material';
import { useMessage } from 'modules/intl';
import PieChart from './PieChart';
import LabelChartSkeleton from './LabelChartSkeleton';
import { LabelNoData } from './LabelNoData';
import { PieChartData } from './utils';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
    maxHeight: theme.spacing(32.5),
    minHeight: theme.spacing(32.5),
    marginRight: theme.spacing(3)
  },
  typography: {
    color: theme.palette.text.secondary
  }
}));

type ClientComponentProps = {
  data: PieChartData;
  loading: boolean;
  isEmpty: boolean;
  setGetCurrentPage?: React.Dispatch<React.SetStateAction<number>> | undefined;
};

export const ClientComponent: React.FC<ClientComponentProps> = ({
  data,
  loading,
  isEmpty,
  setGetCurrentPage
}: ClientComponentProps) => {
  const classes = useStyles();
  const name = useMessage('insights.timeSheetLabels.clients');
  return (
    <Paper
      elevation={3}
      data-testid={'source-by-client-chart-container'}
      className={classes.container}
    >
      <Grid container direction="column" spacing={1}>
        <Grid item>
          <Typography
            className={classes.typography}
            variant="h6"
            data-testid="client-chart-title"
          >
            {name}
          </Typography>
        </Grid>
        <Grid item>
          {loading ? (
            <LabelChartSkeleton />
          ) : isEmpty ? (
            <LabelNoData />
          ) : (
            <PieChart
              data={data}
              labelType="CLIENT"
              setGetCurrentPage={setGetCurrentPage}
            />
          )}
        </Grid>
      </Grid>
    </Paper>
  );
};
export default memo(ClientComponent);
